import axios from "axios";
// const tgId = window?.Telegram?.WebApp?.initDataUnsafe?.user?.
// const tgId = window?.Telegram?.WebApp?.initDataUnsafe?.user?.id ? window?.Telegram?.WebApp?.iniditDataUnsafe?.user?.id : "1598016165";
const tgId = window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
  ? window?.Telegram?.WebApp?.initDataUnsafe?.user?.id
  : "1598016165";
// const tgId = window?.Telegram?.WebApp?.initDataUnsafe?.user.id
export const baseUrl = "https://api.hasana.day/";
const instance = axios.create({
  baseURL: baseUrl,
});
instance.defaults.headers.common["Authorization"] = `Telegram ${tgId}`;
export default instance;

// "http://137.184.3.22/"

// Production: "http://api.hasana.day/"

// https://api.monestore.uz/
